module.exports = __webpack_public_path__ + "static/media/Circo2024_15.75375a8a.webp";